import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';

function NewsletterSignup() {
  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 400, mx: 'auto' }}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Get 15% Off Your First Order
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Sign up for our newsletter and receive exclusive offers!
        </Typography>
        <Button variant="contained" fullWidth href="https://email.everbee.io/subscribe?shopName=KBrosLeather&ref=AKSaNVJp" target='_blank' rel='noopener noreferrer'>
          Sign Up
        </Button>
      </Paper>
    </Box>
  );
}

export default NewsletterSignup;
